import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, TextField, Container, Typography, Box,
         IconButton, InputAdornment, CircularProgress,
 } from '@mui/material'; 
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function ResetPassword() {
    const navigate = useNavigate();
    const { uid, token } = useParams(); // Fix: Access uid and token from useParams
    const [newPassword, setNewPassword] = useState({
        password: "",
        confirm_password: ""
    });
    const [error, setError] = useState(""); // Define error state
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false); // Loading state
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleOnChange = (e) => {
        setNewPassword({ ...newPassword, [e.target.name]: e.target.value }); // Fix: e.target.name typo
    };

    const data = {
        'password': newPassword.password,
        'confirm_password': newPassword.confirm_password,
        'uidb64': uid,
        'token': token
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true
        try {
            const response = await axios.patch(`${apiUrl}/api/v1/auth/set-new-password/`, data);
            const result = response.data;
    
            if (response.status === 200) {
                toast.success(result.message);
                navigate('/login');
            }
        } catch (error) {
            if (error.response && error.response.data) {
                const errData = error.response.data;
    
                // Handle token expiration or invalid token
                if (error.response.status === 401) {
                    toast.error(errData.message || "The reset link is invalid or has expired.");
                } else if (errData.password) {
                    toast.error(errData.password[0]); // Display password mismatch error in toast
                } else {
                    toast.error("An error occurred. Please try again.");
                }
            } else {
                toast.error("An unexpected error occurred.");
            }
        } finally {
            setLoading(false); // Reset loading state
        }
    };    

    return (
        <>
            <Header />
            <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
                <HomeIcon fontSize="large" />
                <Typography variant="h4" ml={1}>
                    Enter Your New Password
                </Typography>
            </Box>
            <Container maxWidth="sm">
                <form onSubmit={handleSubmit}>
                    {error && <Typography color="error">{error}</Typography>}
                    <TextField
                        label="New Password"
                        name="password"
                        value={newPassword.password}
                        onChange={handleOnChange}
                        type={showPassword ? "text" : "password"}
                        // type="password"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        required
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{ style: { fontSize: '1rem' } }}
                    />
                    <TextField
                        label="Confirm Password"
                        name="confirm_password" // Fix: Use the correct field name
                        value={newPassword.confirm_password}
                        onChange={handleOnChange}
                        type={showConfirmPassword ? "text" : "password"}
                        // type="password"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        required
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{ style: { fontSize: '1rem' } }}
                    />
                    {/* <Button type="submit" variant="contained" color="primary" fullWidth>
                        Submit
                    </Button> */}
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={loading} // Disable button while loading
                      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null} // Show spinner
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </Button>
                </form>
            </Container>
        </>
    );
}

export default ResetPassword;

// import React, {useState} from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import api from '../utils/axiosInstance';
// import { toast } from 'react-toastify';
// import { Button, TextField, Container, Typography, Box, CircularProgress } from '@mui/material'; 
// import HomeIcon from '@mui/icons-material/Home';
// import Header from './Header';

// function ResetPassword() {
//     const navigate = useNavigate()
//     const [uid, token] = useParams()
//     const [newPassword, setNewPassword] = useState({
//         password:"",
//         confirm_password:""
//     })
//     const handleOnChange = (e) => {
//         setNewPassword({...newPassword, [e.target.name]:e.target.value})
//     }
//     const data = {
//         'password': newPassword.confirm_password,
//         'confirm_password': newPassword.confirm_password,
//         'uidb64': uid,
//         'token': token
//     }
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const response = await api.patch("/auth/set-new-password/", data)
//         const result = response.data
//         if (response.status === 200) {
//             navigate('/login')
//             toast.success(result.message)
//         }
//     }

//   return (
//     <>
//       <Header />
//       <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
//         <HomeIcon fontSize="large" />
//         <Typography variant="h4" ml={1}>
//           Enter Your New Password
//         </Typography>
//       </Box>
//       <Container maxWidth="sm">
//         <form onSubmit={handleSubmit}>
//           <TextField
//             label="New Password"
//             name="password"
//             value={newPassword.password}
//             onChange={handleOnChange}
//             type="password"
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//           />
//           <TextField
//             label="Confirm Password"
//             name="password2"
//             value={newPassword.confirm_password}
//             onChange={handleOnChange}
//             type="password"
//             variant="outlined"
//             margin="normal"
//             fullWidth
//             required
//           />
//           <Button type="submit" variant="contained" color="primary" fullWidth>
//             Submit
//           </Button>
//         </form>
//       </Container>
//     </>
//   )
// }

// export default ResetPassword
